import React from 'react';
import { isAfter, parseISO } from 'date-fns';
import { Alert, Typography } from '@mui/material';
import { AlertCircle } from 'react-feather';
import { getFormattedFullDateFromIsoString } from '~/src/utils/date';

type CanceledBannerProps = {
  endDate: string;
  extra?: React.ReactNode;
};

export const CanceledBanner = ({ endDate, extra }: CanceledBannerProps) => {
  const isAfterPeriodEnd = isAfter(new Date(), parseISO(endDate));
  const formattedEndDate = getFormattedFullDateFromIsoString(endDate);

  return (
    <Alert
      data-testid="subscription-canceled-banner"
      icon={<AlertCircle color="black" />}
      severity="warning"
      sx={{ background: '#fff1c8' }}
      variant="standard"
    >
      <Typography variant={'body1'}>
        {isAfterPeriodEnd
          ? `Your subscription was canceled on ${formattedEndDate}`
          : `Your subscription is set to cancel on ${formattedEndDate}`}
      </Typography>
      {extra}
    </Alert>
  );
};
